import { Field, Form } from 'react-final-form';

import FormCheckboxGroup from 'components/Inputs/FormInputs/FormCheckboxGroup';
import FormDropdown from 'components/Inputs/FormInputs/FormDropdown';
import {
  Amenity,
  HotelChainGroup,
  useHotelChainGroupFiltersQuery,
} from 'generated/graphql';
import { useAppSelector } from 'store/store';

import { HotelSearchFilters } from './HotelSearchResultList';

const RADIUS_FILTERS = {
  value: 'radius',
  label: 'Distance',
  options: [
    {
      value: 1,
      label: 'Within 1 mile only',
    },
    {
      value: 5,
      label: 'Within 5 miles only',
    },
    {
      value: 10,
      label: 'Within 10 miles only',
    },
    {
      value: 25,
      label: 'Within 25 miles only',
    },
  ],
};

interface FilterMenuProps {
  onFilterChange: (filters: HotelSearchFilters) => void;
  filters: HotelSearchFilters;
}

const FilterMenu = ({ onFilterChange, filters }: FilterMenuProps) => {
  const { amenities } = useAppSelector((state) => state.enums);
  const { data: hotelChainGroupsData } = useHotelChainGroupFiltersQuery();

  const hotelChainGroupOptions = hotelChainGroupsData?.hotelChainGroups ?? [];

  const hotelChainGroupFilterChange = (hotelChainGroup: HotelChainGroup) => {
    onFilterChange({ hotelChainGroup });
  };

  const handleAmenitiesChange = (amenities: Amenity[]) => {
    const accessibleRoomsOnly = amenities.includes(Amenity.AdaAccommodation);
    const nextFilters: HotelSearchFilters = { amenities };

    if (accessibleRoomsOnly !== Boolean(filters.accessibleRoomsOnly)) {
      nextFilters.accessibleRoomsOnly = accessibleRoomsOnly;
    }

    onFilterChange(nextFilters);
  };

  const handleDistanceChange = (radius: { value: number; label: string }) => {
    onFilterChange({ radius: radius.value });
  };

  return (
    <Form
      initialValues={{
        ...filters,
        radius:
          RADIUS_FILTERS.options.find(
            (option) => option.value === filters.radius,
          ) || RADIUS_FILTERS.options[0],
      }}
      onSubmit={() => {}}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4">
            <Field
              name="hotelChainGroup"
              component={FormDropdown}
              labelText="BRAND"
              labelClassName="font-oswald font-bold mb-2"
              placeHolder="Select Brand..."
              onChange={hotelChainGroupFilterChange}
              options={[
                { name: 'All Brands', code: '' },
                ...hotelChainGroupOptions,
              ]}
              renderOption={(option: { name?: string; code?: string }) =>
                option.name || option.code || 'Unknown'
              }
            />
          </div>
          <div className="mb-4">
            <Field
              name="radius"
              component={FormDropdown}
              labelClassName="font-oswald font-bold mb-2"
              labelText="DISTANCE"
              placeHolder="Select Distance..."
              onChange={handleDistanceChange}
              options={RADIUS_FILTERS.options}
              renderOption={(option: { value: number; label: string }) =>
                option.label
              }
            />
          </div>
          <div className="mb-4">
            <Field
              name="amenities"
              labelText="AMENITIES"
              labelClassName="font-oswald font-bold mb-2"
              component={FormCheckboxGroup}
              options={amenities}
              onGroupChange={handleAmenitiesChange}
            />
          </div>
        </form>
      )}
    />
  );
};

export default FilterMenu;
